var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "trade-dividend-wrapper" },
    [
      _c("section-title", {
        staticClass: "top-title",
        attrs: { title: _vm.$t("tradeDividend.poolTitle") }
      }),
      _vm._v(" "),
      _c("pool"),
      _vm._v(" "),
      _c("section-title", {
        attrs: {
          title: _vm.$t("tradeDividend.listTitle"),
          help: _vm.$t("tradeDividend.help")
        }
      }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "content" },
        [
          _c(
            "div",
            { staticClass: "staking-detail" },
            [
              _c("div", { staticClass: "item" }, [
                _c("div", [_vm._v(_vm._s(_vm.$t("tradeDividend.price")))]),
                _vm._v(" "),
                _c("div", { staticClass: "bold" }, [
                  _vm._v(_vm._s(_vm.myFullBtcIncome))
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "light" }, [
                  _vm._v(_vm._s(_vm.myFullIncome))
                ])
              ]),
              _vm._v(" "),
              _vm._l(["BTC", "ETH", "USDT"], function(tokenType) {
                return _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "click-outside",
                        rawName: "v-click-outside",
                        value: _vm.hideMyList,
                        expression: "hideMyList"
                      }
                    ],
                    key: tokenType,
                    staticClass: "item __pointer",
                    on: {
                      click: function($event) {
                        $event.stopPropagation()
                        return _vm.showMyList(tokenType)
                      }
                    }
                  },
                  [
                    _c("div", [_vm._v(_vm._s(tokenType))]),
                    _vm._v(" "),
                    _c("div", { staticClass: "bold" }, [
                      _vm._v(
                        "\n                    " +
                          _vm._s(
                            _vm.myDividend[tokenType]
                              ? _vm.formatNum(
                                  _vm.myDividend[tokenType].dividendAmount,
                                  tokenType
                                )
                              : 0
                          ) +
                          "\n                    "
                      ),
                      _c("span", {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowMyDividendList(tokenType),
                            expression: "isShowMyDividendList(tokenType)"
                          }
                        ],
                        staticClass: "down-icon"
                      }),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value:
                                _vm.isShowMyDividendList(tokenType) &&
                                _vm.isShowMyList === tokenType,
                              expression:
                                "isShowMyDividendList(tokenType) && isShowMyList === tokenType"
                            }
                          ],
                          staticClass: "item-content"
                        },
                        _vm._l(_vm.getMyList(tokenType), function(
                          dividentItem,
                          i
                        ) {
                          return _c("div", { key: i, staticClass: "row" }, [
                            _c("span", { staticClass: "light" }, [
                              _vm._v(_vm._s(dividentItem.tokenSymbol) + ": ")
                            ]),
                            _vm._v(" "),
                            _c("span", { staticClass: "amount" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.formatNum(dividentItem.amount, tokenType)
                                )
                              )
                            ])
                          ])
                        }),
                        0
                      )
                    ])
                  ]
                )
              })
            ],
            2
          ),
          _vm._v(" "),
          _c("locking"),
          _vm._v(" "),
          _c(
            "wallet-table",
            {
              staticClass: "dividend-table tb",
              attrs: {
                clickRow: _vm.clickRow,
                headList: _vm.headList,
                contentList: _vm.contentList
              }
            },
            [
              _vm.activeRow
                ? _c(
                    "div",
                    {
                      staticClass: "slot-row __tb_row __tb_content_row",
                      attrs: { slot: _vm.activeIndex + "Row" },
                      slot: _vm.activeIndex + "Row"
                    },
                    [
                      _c("div", { staticClass: "__tb_cell" }),
                      _vm._v(" "),
                      _c("div", { staticClass: "__tb_cell" }),
                      _vm._v(" "),
                      _vm._l(["BTC", "ETH", "USDT"], function(tokenType) {
                        return _c(
                          "div",
                          { key: tokenType, staticClass: "__tb_cell" },
                          _vm._l(
                            _vm.activeRow[tokenType]
                              ? _vm.activeRow[tokenType].tokenDividends
                              : [],
                            function(item, i) {
                              return _c("div", { key: i }, [
                                _vm._v(
                                  "\n                        " +
                                    _vm._s(
                                      item.tokenSymbol +
                                        " " +
                                        _vm.formatNum(item.amount, tokenType)
                                    ) +
                                    "\n                    "
                                )
                              ])
                            }
                          ),
                          0
                        )
                      }),
                      _vm._v(" "),
                      _c("div", { staticClass: "__tb_cell" })
                    ],
                    2
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm._l(_vm.contentList, function(item, i) {
                return _c("span", {
                  key: i,
                  staticClass: "arrow-icon",
                  class: { active: _vm.activeIndex === i },
                  attrs: { slot: i + "BTCAfter" },
                  slot: i + "BTCAfter"
                })
              }),
              _vm._v(" "),
              _vm._l(_vm.contentList, function(item, i) {
                return _c("span", {
                  key: i,
                  staticClass: "arrow-icon",
                  class: { active: _vm.activeIndex === i },
                  attrs: { slot: i + "ETHAfter" },
                  slot: i + "ETHAfter"
                })
              }),
              _vm._v(" "),
              _vm._l(_vm.contentList, function(item, i) {
                return _c("span", {
                  key: i,
                  staticClass: "arrow-icon",
                  class: { active: _vm.activeIndex === i },
                  attrs: { slot: i + "USDTAfter" },
                  slot: i + "USDTAfter"
                })
              }),
              _vm._v(" "),
              _c("pagination", {
                staticClass: "__tb_pagination",
                attrs: {
                  slot: "tableBottom",
                  currentPage: _vm.currentPage + 1,
                  toPage: _vm.fetchList,
                  totalPage: _vm.totalPage
                },
                slot: "tableBottom"
              })
            ],
            2
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }